import { createActions } from 'redux-actions';

import { actionTypes } from './actionTypes';
import { API } from '@service';
import {
  formatIntegrationModuleList,
  getModuleListItem,
  getPermissionToAPI,
} from './projects';

const {
  systemSettings: {
    CHANGE_GUIDING_PRINCIPLE,
    CHANGE_NAVIGATION,
    CHANGE_VALUE_DRIVER,
    CHANGE_WHITE_LIST,
    CHANGE_WHITE_LIST_USER,
    REMOVE_WHITE_LIST_USER,
    CHANGE_FETCHING_VALUE_DRIVER_TMPLT,
  },
  common: {
    CHANGE_LOADING,
    CHANGE_SPN_ID,
    CHANGE_PROJECT_INSTANCE,
    CHANGE_SETTING_COMPANY_INSTANCE,
  },
} = actionTypes;

const actions = createActions(
  {},
  CHANGE_LOADING,
  CHANGE_GUIDING_PRINCIPLE,
  CHANGE_NAVIGATION,
  CHANGE_VALUE_DRIVER,
  CHANGE_WHITE_LIST,
  CHANGE_SPN_ID,
  CHANGE_PROJECT_INSTANCE,
  CHANGE_SETTING_COMPANY_INSTANCE,
  CHANGE_WHITE_LIST_USER,
  REMOVE_WHITE_LIST_USER,
  CHANGE_FETCHING_VALUE_DRIVER_TMPLT,
);
export const projectActions = createActions(
  {},
  ...Object.values(actionTypes.projects),
);

const fetchNavigationTemplate =
  (type = 'Integration') =>
  async (dispatch, getState) => {
    dispatch(actions.changeLoading(true));

    const result = await API.getNavigatorTemplateRequest(type);
    const data = formatIntegrationModuleList(result?.integrationTabs || []);
    const currentTab = data.tabs[0]?.id;
    dispatch(
      projectActions.saveProjectDetail(
        {
          currentTab,
        } || {},
      ),
    );
    dispatch(actions.changeLoading(false));

    dispatch(
      actions.changeNavigation({
        navigatorName: result?.name,
        ...data,
        type: result?.type,
      }),
    );
  };

const initialNavigatorData = () => (dispatch) => {
  dispatch(actions.changeNavigation({}));
};

const saveNavigatorTemplate =
  ({ tabLists, data }) =>
  async (dispatch, getState) => {
    const {
      systemSettings: {
        navigatorData: { tabs },
      },
    } = getState();

    const currentTabList = tabLists || tabs;

    const integrationTabs = currentTabList.map((tab) => ({
      tabName: tab.text,
      isDefaultTab: tab.deletable ? 0 : 1,
      moduleList: getModuleListItem(data[tab.id]),
      permission: getPermissionToAPI(tab.permission),
    }));

    const result = await API.updateNavigatorTemplateRequest({
      integrationNavigatorName: data.integrationNavigatorName,
      integrationTabs,
      type: data.type,
    });

    return {
      success: result?.message.includes('success'),
    };
  };

const fetchValuedricerTemplate = (instanceId) => async (dispatch) => {
  dispatch(actions.changeFetchingValueDriverTmplt(true));

  const result = await API.getValuedriverTemplateRequest(instanceId);

  dispatch(actions.changeValueDriver(result || {}));
  dispatch(actions.changeFetchingValueDriverTmplt(false));
};

const saveValuedriverTemplate = async (instanceId, params) => {
  const result = await API.updateValuedriverTemplateRequest({
    instanceId,
    valueDriverInfo: params,
  });

  return { success: result?.message.includes('success') };
};

const initialValuedriverData = () => (dispatch) => {
  dispatch(actions.changeValueDriver({}));
};

const fetchGudingPrincipleTemplate = (companyInstance) => async (dispatch) => {
  dispatch(actions.changeLoading(true));

  const result = await API.getGuidingPrincipleTemplateRequest(companyInstance);

  if (Array.isArray(result.guidingPrincipleTemplateInfo)) {
    result.guidingPrincipleTemplateInfo.forEach((i) => {
      try {
        const guidingPrinciple = JSON.parse(i.guidingPrinciple);
        const title = JSON.parse(i.title);
        if (
          typeof guidingPrinciple === 'object' ||
          typeof guidingPrinciple === 'string'
        ) {
          i.guidingPrinciple = guidingPrinciple;
        }
        if (typeof title === 'object' || typeof title === 'string') {
          i.title = title;
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  dispatch(actions.changeGuidingPrinciple(result));

  dispatch(actions.changeLoading(false));
};

const saveGuidingPrincipleTemplate = async (params) => {
  // params.guidingPrincipleList = params.guidingPrincipleList.filter(
  //   ({ guidingPrinciple, summary, title }) =>
  //     guidingPrinciple?.trim() || summary?.trim() || title?.trim(),
  // );
  params.guidingPrincipleList.forEach((i) => {
    try {
      if (typeof i.guidingPrinciple === 'string') {
        i.guidingPrinciple = JSON.parse(i.guidingPrinciple);
      }
      if (typeof i.title === 'string') {
        i.title = JSON.parse(i.title);
      }
    } catch (e) {
      console.log(e);
    }
  });
  const result = await API.updateGuidingPrincipleTemplateRequest(params);

  return { success: result?.message.includes('success') };
};

// const saveGuidingPrincipleSystemSetting = async (params) => {
//   const { buySideValues, sellSideValues } = params;
//   const valuesArray = [
//     { data: buySideValues, companyInstance: 'Integration' },
//     { data: sellSideValues, companyInstance: 'Divestiture' },
//   ].filter((i) => i.data);
//   const results = await Promise.all(
//     valuesArray.map((i) =>
//       saveGuidingPrincipleByCompanyInstance(i.data, i.companyInstance),
//     ),
//   );
//   return {
//     success: (results || []).every((i) => i?.message.includes('success')),
//   };
// };

// const saveGuidingPrincipleByCompanyInstance = (data, companyInstance) => {
//   // data.guidingPrincipleList = data.guidingPrincipleList.filter(
//   //   ({ guidingPrinciple, summary, title }) =>
//   //     guidingPrinciple?.trim() || summary?.trim() || title?.trim(),
//   // );
//   data.guidingPrincipleList.forEach((i) => {
//     try {
//       if (typeof i.guidingPrinciple === 'string') {
//         i.guidingPrinciple = JSON.parse(i.guidingPrinciple);
//       }
//       if (typeof i.title === 'string') {
//         i.title = JSON.parse(i.title);
//       }
//     } catch (e) {
//       console.log(e);
//     }
//   });
//   return API.updateGuidingPrincipleTemplateRequest(data, companyInstance);
// };

const getWhiteListMemberList = () => async (dispatch) => {
  dispatch(
    actions.changeWhiteList({
      isFetching: true,
    }),
  );

  const result = (await API.getWhiteListMemberListRequest()) || [];

  dispatch(
    actions.changeWhiteList({
      listData: result,
      currentGUIDs: result.map((d) => d.guid),
      isFetching: false,
    }),
  );
};

const queryMemberByText = (text) => async (_, getState) => {
  const result = (await API.queryMemberByTextRequest(text)) || [];

  return result;
};

const submitAddedUser =
  (data = []) =>
  async (dispatch) => {
    const result = await API.submitAddedUsersRequest(data);

    dispatch(getWhiteListMemberList());

    return { success: Boolean(result) };
  };

const updateUserPermission = (userInfo) => async (dispatch) => {
  dispatch(
    actions.changeWhiteList({
      isFetching: true,
    }),
  );

  const res = await API.updateWhitelistMemberRequest(userInfo);
  if (res) {
    await dispatch(actions.changeWhiteListUser({ user: res }));
  }

  // await dispatch(getWhiteListMemberList());

  dispatch(
    actions.changeWhiteList({
      isFetching: false,
    }),
  );
};

const deleteWhiteListMember = (guid) => async (dispatch) => {
  if (!guid) {
    return;
  }

  await API.deleteWhiteListMemberRequest(guid);

  await dispatch(actions.removeWhiteListUser(guid));
};

const getSystemLevelSpnId = () => async (dispatch) => {
  const res = await API.getSystemSpnId();
  if (res?.spnName) {
    dispatch(actions.changeSpnId(res.spnName));
  }
};

export default {
  ...actions,
  fetchNavigationTemplate,
  saveNavigatorTemplate,
  initialNavigatorData,
  fetchValuedricerTemplate,
  initialValuedriverData,
  saveValuedriverTemplate,
  fetchGudingPrincipleTemplate,
  saveGuidingPrincipleTemplate,
  queryMemberByText,
  getWhiteListMemberList,
  submitAddedUser,
  deleteWhiteListMember,
  updateUserPermission,
  // saveGuidingPrincipleSystemSetting,
  getSystemLevelSpnId,
};
